import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/img/icons/maximize.svg'


const _hoisted_1 = ["aria-label", "title"]
const _hoisted_2 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFullscreen && _ctx.toggleFullscreen(...args))),
    class: "border-0 bg-transparent p-0",
    "aria-label": _ctx.$t('header.toggle_fullscreen'),
    title: _ctx.$t('header.toggle_fullscreen')
  }, [
    _createElementVNode("img", {
      src: _imports_0,
      alt: _ctx.$t('header.toggle_fullscreen')
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}